const t = "_actionList_oy452_1", i = "_actionListItem_oy452_5", o = {
  actionList: t,
  actionListItem: i
};
export {
  t as actionList,
  i as actionListItem,
  o as default
};
//# sourceMappingURL=action-list.module.less.js.map
